/**
 * Google Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import type { IconProps } from '../../types';

export function GoogleIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Google',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faGoogle}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
